module.exports = __webpack_public_path__ + "static/media/rumi-product-img@3x.b6ab9688.png";